import React from 'react';
import ContactForm from './ContactForm';
import Info from './Info';
import './Contacts.css'



const Contacts = () => {
    return (
        <div>
            <div className='contacts'>
            <h2 className="contacts_title">Contact me</h2>
            <div className="contacts_items">          
                <ContactForm/>
                <Info/>
             </div> 
               
        </div>
        </div>
    )
}

export default Contacts
